import { SectionIndexItem } from '../components/SectionIndexAutocomplete';

function makeItems(
  tabKey: string,
  tabLabel: string,
  sectionLabel: string,
  sectionId: string,
  labels: string[]
): SectionIndexItem[] {
  return labels.map((label) => ({
    label,
    sectionLabel,
    sectionId,
    tabKey,
    tabLabel,
  }));
}

export const lotSectionIndex: SectionIndexItem[] = [
  // region — Características e Região
  ...makeItems(
    'region',
    'Características e Região',
    'Usos Predominantes',
    'region-usos-predominantes',
    ['Usos Predominantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Infraestrutura Urbana',
    'region-infraestrutura-urbana',
    ['Infraestrutura Urbana']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Serviços Públicos e Comunitários',
    'region-servicos-publicos',
    ['Serviços Públicos e Comunitários']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Padrão das Edificações na Região',
    'region-padrao-edificacoes',
    ['Padrão das Edificações na Região']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Influências',
    'region-influencias',
    ['Influências', 'Valorizantes', 'Desvalorizantes']
  ),
  ...makeItems(
    'region',
    'Características e Região',
    'Outras características',
    'region-outras-caracteristicas',
    [
      'Outras características',
      'Via de Acesso',
      'Descreva a Via de Acesso',
      'Região',
    ]
  ),

  // evaluating_unit — Unidade Avaliando
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Vistoria',
    'evaluating-unit-vistoria',
    ['Vistoria', 'Data da Vistoria']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Características Gerais',
    'evaluating-unit-caracteristicas-gerais',
    ['Destinação', 'Nível de Restrição de Uso', 'Superfície', 'Ocupação']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Posição e Inserção',
    'evaluating-unit-posicao-insercao',
    ['Orientação Solar', 'Vista', 'Implantação/Inserção']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Benfeitorias',
    'evaluating-unit-benfeitorias',
    ['Benfeitorias']
  ),
  ...makeItems(
    'evaluating_unit',
    'Unidade Avaliando',
    'Uso e ocupação do solo',
    'evaluating-unit-uso-solo',
    [
      'Zoneamento',
      'Usos permitidos pelo zoneamento',
      'Taxa de ocupação máxima (%)',
      'Altura máxima permitida (m)',
      'Coeficiente de aproveitamento (%)',
      'Recuo frontal (m)',
      'Recuo lateral (m)',
      'Recuo fundos (m)',
    ]
  ),

  // land_and_fencing — Lote e Cercamento
  ...makeItems(
    'land_and_fencing',
    'Lote e Cercamento',
    'Lote da unidade',
    'land-lote-unidade',
    ['Posição', 'Cota/Greide', 'Formato Aproximado', 'Inclinação']
  ),
  ...makeItems(
    'land_and_fencing',
    'Lote e Cercamento',
    'Tipo de cercamento',
    'land-tipo-cercamento',
    ['Cercamento', 'Frente', 'Lateral / Fundo', 'Vocação Principal']
  ),
  ...makeItems(
    'land_and_fencing',
    'Lote e Cercamento',
    'Dados Físicos',
    'land-dados-fisicos',
    ['Área (m²)', 'Testada', 'Profundidade equivalente (m)', 'Lados']
  ),

  // enterprise — Empreendimento
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Gerais',
    'enterprise-dados-gerais',
    [
      'Dados Gerais',
      'Padrão do Empreendimento',
      'Estado de Conservação',
      'Controle de Acesso',
      'Nº Total de Unidades',
      'Nº de Und. de Tipologia',
      'Fração Ideal',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Terreno',
    'enterprise-terreno',
    [
      'Terreno',
      'Cercamento',
      'Tipo de Cercamento Frente',
      'Tipo de Cercamento Lateral/Fundo',
      'Ocupação do terreno',
    ]
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Equipamentos',
    'enterprise-equipamentos',
    ['Equipamentos', 'N° Salas de Lazer']
  ),
  ...makeItems(
    'enterprise',
    'Empreendimento',
    'Dados Administrativos',
    'enterprise-dados-administrativos',
    [
      'Dados Administrativos',
      'Taxa de Condomínio',
      'Administradora do Condomínio',
      'Telefone Administradora',
      'E-mail Administradora',
    ]
  ),
];
